/**************************************************
 * Nombre:       Fondo_Seccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Fondo_Seccion = ({fondo}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `linear-gradient(0deg, rgba(83, 86, 255, 0.50) 0%, rgba(83, 86, 255, 0.50) 100%), url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                borderBottomLeftRadius: 50,
                borderBottomRightRadius: 50,
                height: !masSM ? '50vh' : '90vh'
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Fondo_Seccion  